import script from "./MailSender.vue?vue&type=script&setup=true&lang=ts"
export * from "./MailSender.vue?vue&type=script&setup=true&lang=ts"

import "./MailSender.vue?vue&type=style&index=0&id=828520ee&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-828520ee"]])

export default __exports__